module.exports = __webpack_public_path__ + "img/lsjn4.fc832295.jpg";